import { connect } from 'react-redux';
import type { State } from 'state';
import { getPortalId } from 'state/selectors/context';
import { getProjectId } from 'state/selectors/portal';
import { ForgeElement } from './forge-element';

/**
 * Resolves the project id of the portal currently in context (if any) and
 * injects it into `ForgeElement` as the `projectId` prop.
 *
 * On hub portal pages this lets the Forge header/footer modules attach the
 * portal resource context (`{ resourceId, resourceType: 'PROJECT' }`) to the
 * fetch-extensions request, matching the classic (non-hub) portal home page.
 */
const mapStateToProps = (state: State): { projectId?: number } => {
	const portalId = getPortalId(state);
	return {
		projectId: getProjectId(state, portalId),
	};
};

export default connect(mapStateToProps, {})(ForgeElement);
